export const scrollToBottom = () =>
  window.scrollTo({
    top: document.body.scrollHeight,
    behavior: "smooth",
  });

export const scrollToElementById = (id: string) =>
  document.getElementById(id)?.scrollIntoView({
    behavior: "auto",
  });
